(function(){
  var reduce=false;
  try{ document.documentElement.classList.add('js');
       reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches; }catch(e){ return; }

  function showAll(){ try{ var n=document.querySelectorAll('.mf-reveal'); for(var i=0;i<n.length;i++) n[i].classList.add('is-in'); }catch(e){} }

  function reveals(){
    try{
      var els=document.querySelectorAll('.mf-reveal');
      if(!els.length) return;
      if(reduce || !('IntersectionObserver' in window)){ showAll(); return; }
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(!en.isIntersecting) return;
          var el=en.target, d=parseFloat(el.getAttribute('data-mf-delay')||'0');
          setTimeout(function(){ el.classList.add('is-in'); }, Math.min(d,280));
          io.unobserve(el);
        });
      },{rootMargin:'0px 0px -12% 0px',threshold:.12});
      for(var i=0;i<els.length;i++) io.observe(els[i]);
    }catch(e){ showAll(); }
  }

  function heroVideo(){
    try{
      var v=document.querySelector('[data-mf-hero-video]');
      if(!v || reduce) return;
      if(window.matchMedia('(max-width: 749px)').matches) return;
      var src=v.querySelector('source[data-src]');
      if(!src) return;
      src.setAttribute('src', src.getAttribute('data-src'));
      v.load();
      var p=v.play();
      if(p && p.then) p.then(function(){ v.classList.add('is-playing'); }).catch(function(){});
      else v.classList.add('is-playing');
    }catch(e){}
  }

  function tabs(){
    try{
      var groups=document.querySelectorAll('[data-mf-tabs]');
      Array.prototype.forEach.call(groups,function(g){
        var btns=g.querySelectorAll('.mf-tab'), panels=g.querySelectorAll('.mf-panel');
        function select(i){
          Array.prototype.forEach.call(btns,function(b,j){
            b.setAttribute('aria-selected', j===i?'true':'false');
            b.setAttribute('tabindex', j===i?'0':'-1');
          });
          Array.prototype.forEach.call(panels,function(p,j){ p.hidden = j!==i; });
        }
        Array.prototype.forEach.call(btns,function(b,i){
          b.addEventListener('click',function(){ select(i); });
          b.addEventListener('keydown',function(ev){
            var k=ev.key, n=null;
            if(k==='ArrowRight') n=(i+1)%btns.length;
            else if(k==='ArrowLeft') n=(i-1+btns.length)%btns.length;
            else if(k==='Home') n=0; else if(k==='End') n=btns.length-1;
            if(n!==null){ ev.preventDefault(); select(n); btns[n].focus(); }
          });
        });
        select(0);
      });
    }catch(e){}
  }

  function magnetic(){
    if(reduce) return;
    try{
      if(window.matchMedia('(pointer: coarse)').matches) return;
      var els=document.querySelectorAll('.mf-cta');
      Array.prototype.forEach.call(els,function(el){
        el.addEventListener('mousemove',function(e){
          var r=el.getBoundingClientRect();
          var x=(e.clientX-(r.left+r.width/2))*0.15;
          var y=(e.clientY-(r.top+r.height/2))*0.15;
          el.style.transform='translate('+x.toFixed(2)+'px,'+y.toFixed(2)+'px)';
        });
        el.addEventListener('mouseleave',function(){ el.style.transform=''; });
      });
    }catch(e){}
  }

  function run(){ reveals(); heroVideo(); tabs(); magnetic(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
})();
